import { Controller } from "@hotwired/stimulus";

/**
 * News feed — the text of a post: paragraphs, bold, lists, links. The server
 * keeps only those (News::BodySanitizer); this editor offers nothing else,
 * and a paste comes in as plain text.
 */
export default class extends Controller {
  static targets = ["area", "input"];

  connect() {
    this.sync();
  }

  bold() { this.run("bold"); }
  bullets() { this.run("insertUnorderedList"); }
  numbers() { this.run("insertOrderedList"); }

  link(event) {
    const url = window.prompt(event.currentTarget.dataset.prompt || "https://", "https://");
    if (url && /^https?:\/\//i.test(url)) this.run("createLink", url);
  }

  paste(event) {
    event.preventDefault();
    const text = (event.clipboardData || window.clipboardData).getData("text/plain");
    document.execCommand("insertText", false, text);
  }

  run(command, value = null) {
    this.areaTarget.focus();
    document.execCommand(command, false, value);
    this.sync();
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }));
  }

  sync() {
    const empty = this.areaTarget.textContent.trim() === "" && !this.areaTarget.querySelector("li");
    if (empty) this.areaTarget.innerHTML = "";
    this.inputTarget.value = empty ? "" : this.areaTarget.innerHTML;
  }
}
